import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
  ViewChild,
} from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'src/app/services/message.service';
import { SupplierAssessmentService } from 'src/app/services/manager/supplier-assessment.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/components/shared/confirmation-dialog/confirmation-dialog.component';
import { ActivatedRoute } from '@angular/router';
import { ExcelDownloadService } from 'src/app/services/common/excel-download.service';
import { ExcelSheetConfig } from 'src/app/components/models/excel-dto.model';
import { CommonService } from 'src/app/services/common/common.service';
import { ReactiveFormHelperService } from 'src/app/services/common/reactive-form-helper.service';
import { PreviewDocumentModalComponent } from 'src/app/components/common/preview-document-modal/preview-document-modal.component';

@Component({
  selector: 'app-supplier-questioner',
  templateUrl: './supplier-questioner.component.html',
  styleUrls: ['./supplier-questioner.component.scss'],
})
export class SupplierQuestionerComponent implements OnInit {
  @Input('questionerSubmit') questionerSubmit!: boolean;
  @Input('supplierId1') supplierId1!: number;
  @Output() successfullSubmitQues = new EventEmitter<boolean>();
  @ViewChildren('questionRow') questionRows!: QueryList<ElementRef>;
  @Output() fieldTouchedByChild = new EventEmitter();
  @ViewChild(PreviewDocumentModalComponent)
  previewDocumentModal!: PreviewDocumentModalComponent;

  supplierId!: number;
  supplierQuestionList!: any;
  supplierRemarkList!: any;
  supplierDocumentTypeList: { [key: number]: any } = {};
  checkingError!: boolean;
  isFieldTouched!: boolean;
  sendToSupplierButtonDisabled!: boolean;
  uploadDocumentConfiguration: any;
  allDocumentTypes: any;

  constructor(
    private _supplierSvc: SupplierAssessmentService,
    private spinner: NgxSpinnerService,
    private messageService: MessageService,
    public dialog: MatDialog,
    private _activateRoute: ActivatedRoute,
    private _excelDownloadService: ExcelDownloadService,
    public _commonService: CommonService,
    private reactiveFormHelperService: ReactiveFormHelperService
  ) {
    this._activateRoute.params.subscribe((res: any) => {
      if (res.id) {
        this.supplierId = Number(res.id?.split('&AccessToken=')[0]);
        this._commonService.accessTokenForEmail =
          res.id?.split('&AccessToken=')[1];
      }
    });
  }

  ngOnInit(): void {
    if (window.location.href?.includes('supplier-questioner/'))
      this.sendToSupplierButtonDisabled = true;
    this.GetAllSupplierQuestions();
    this.GetSupplierRemarkList();
    this.GetConfigurationValue();
  }

  GetAllSupplierQuestions() {
    this._supplierSvc.GetAllSupplierQuestions().subscribe((res: any) => {
      if (!res.isSuccess) this.messageService.errorToast(res?.errorMessage);
      else {
        this.supplierQuestionList = this.prepareTableData(res?.data);
        if (this.supplierQuestionList) {
          this.GetAllDocumentType();
          this.getSupplierSubmittedAnswer();
        }
      }
    });
  }

  prepareTableData(data: any) {
    const groupedData: any = [];
    const topicMap: { [key: number]: boolean } = {};

    data?.forEach((item: any) => {
      const topicId = item.topicId;

      if (!topicMap[topicId]) {
        groupedData.push({
          ...item,
          isTopicRow: true,
          isRemarkOtherValueSelected: false,
          questionDocumentTypeIds: item?.questionDocumentTypeIds?.split(','),
          answer: '',
          remark: '',
          otherRemark: null,
          isRemarkFieldChangedToText: false,
          fileData: [
            {
              fileName: '',
              file: null,
              documentTypeId: null,
            },
          ],
        });
        topicMap[topicId] = true;
      } else {
        groupedData.push({
          ...item,
          topic: null,
          isTopicRow: false,
          isRemarkOtherValueSelected: false,
          questionDocumentTypeIds: item?.questionDocumentTypeIds?.split(','),
          answer: '',
          remark: '',
          otherRemark: null,
          isRemarkFieldChangedToText: false,
          fileData: [
            {
              fileName: '',
              file: null,
              documentTypeId: null,
            },
          ],
        });
      }
    });

    return groupedData;
  }

  addMoreFileDataInTable(parentIndex: any) {
    this.supplierQuestionList[parentIndex].fileData.push({
      fileName: '',
      file: null,
      documentTypeId: null,
    });
  }

  GetSupplierRemarkList() {
    this._supplierSvc.GetSupplierRemarkList().subscribe((res: any) => {
      if (!res.isSuccess) this.messageService.errorToast(res?.errorMessage);
      else this.supplierRemarkList = res?.data;
    });
  }

  GetAllDocumentType() {
    this._supplierSvc.GetAllDocumentType().subscribe((res: any) => {
      if (!res.isSuccess) this.messageService.errorToast(res?.errorMessage);
      else {
        this.allDocumentTypes = res?.data ? res?.data : [];
        this.getFilteredDocumentTypes(res?.data);
      }
    });
  }

  supplierRemarkListChange(event: any, index: any) {
    this.supplierQuestionList[index].isRemarkOtherValueSelected =
      event.target.value == 'Others' ? true : false;
  }

  getFilteredDocumentTypes(data: any) {
    this.supplierQuestionList?.forEach((ele: any, index: any) => {
      this.supplierDocumentTypeList[index] = data?.filter((item: any) =>
        ele?.questionDocumentTypeIds?.includes(`${item.id}`)
      );
    });
  }

  GetConfigurationValue() {
    this._supplierSvc
      .GetConfigurationValue({ name: 'DocumentUploadConfig' })
      .subscribe((res: any) => {
        let documentConfigData = JSON.parse(res?.data?.value);
        this.uploadDocumentConfiguration =
          documentConfigData?.Supplier?.SupplierQuestionaireDocument;
      });
  }

  onFileSelected(
    event: any,
    parentIndex: any,
    childIndex: any,
    parentData: any
  ) {
    let fileInput = event.target;
    const file = event?.target?.files[0];

    if (file) {
      const fileSizeInKB = file.size / 1024;
      let len = file?.name?.split('.').length;
      let fileExtension = `.${file?.name?.split('.')[len - 1]}`;
      let fileExtension1 = file?.name?.split('.')[len - 1];

      if (fileSizeInKB > this.uploadDocumentConfiguration?.size) {
        fileInput.value = '';
        return this.messageService.errorToast(
          `Please upload file size less than ${this.uploadDocumentConfiguration?.size}kb`
        );
      }

      if (
        !this.uploadDocumentConfiguration?.DocumentExtensions?.includes(
          fileExtension
        )
      ) {
        fileInput.value = '';
        return this.messageService.errorToast(
          `Please upload only ${this.uploadDocumentConfiguration?.DocumentExtensions?.join(', ')} files`
        );
      }

      this.AddQuestionnaireDocument(
        parentData,
        parentIndex,
        childIndex,
        file,
        fileExtension1,
        file?.name
      );
      parentData.hasDocError = false;
      parentData.hasDocTypeError = false;
    }
  }

  AddQuestionnaireDocument(
    parentData: any,
    parentIndex: any,
    childIndex: any,
    file: any,
    fileExtension: any,
    fileName: any
  ) {
    let formData: any = new FormData();
    formData.append(
      'requestUserLoginName',
      JSON.parse(localStorage.getItem('userData')!).username
    );
    formData.append('data.SupplierId', this.supplierId);
    formData.append(
      'data.SupplierQuestionMasterTXNId',
      parentData?.supplierQuestionMasterTXNId
    );
    formData.append(
      'data.DocumentTypeId',
      parentData?.fileData[childIndex]?.documentTypeId
    );
    formData.append('data.File', file);
    formData.append('data.Extension', fileExtension);

    this._supplierSvc
      .AddQuestionnaireDocument(formData)
      .subscribe((res: any) => {
        if (!res.isSuccess) this.messageService.errorToast(res.errorMessage);
        else {
          // this.isFieldTouched = true;
          // this.fieldTouchedByChild.emit(true);
          this.messageService.successToast('File saved successfully');
          parentData.fileData[childIndex].file = file;
          parentData.fileData[childIndex].fileName = fileName;
          parentData.fileData[childIndex].fileExtension = fileExtension;
          parentData.fileData[childIndex].documentId =
            res?.data?.questionnaireDocumentId[0];
          // parentData.fileData[childIndex]['fileOnServer'] =
          //   true;
          this.supplierDocumentTypeList[parentIndex]?.forEach((ele: any) => {
            if (ele.id == parentData?.fileData[childIndex]?.documentTypeId) {
              parentData.fileData[childIndex].documentTypeName =
                ele.documentType;
            }
          });

          this.checkForDefaultDocument(
            parentData?.categoryId,
            parentData?.id,
            parentData?.fileData[childIndex]?.documentTypeId,
            res?.data?.questionnaireDocumentId?.slice(1) || [],
            { file: file, fileName: fileName, fileExtension: fileExtension }
          );
        }
      });
  }

  deleteFileDataInTable(
    parentIndex: any,
    childIndex: any,
    categoryId?: any,
    questionId?: any,
    documentTypeId?: any
  ) {
    if (
      !this.supplierQuestionList[parentIndex].fileData[childIndex]?.fileName &&
      !this.supplierQuestionList[parentIndex].fileData[childIndex]?.filePath &&
      !this.supplierQuestionList[parentIndex].fileData[childIndex]?.rowOnServer
    ) {
      this.supplierQuestionList[parentIndex].fileData.splice(childIndex, 1);
      // this.isFieldTouched = true;
      // this.fieldTouchedByChild.emit(true);
      this.messageService.successToast('File deleted successfully');
    } else {
      let requestData = {
        questionnairDocumentId:
          this.supplierQuestionList[parentIndex].fileData[childIndex]
            .documentId,
      };
      this._supplierSvc
        .DeleteQuestionnaireDocument(requestData)
        .subscribe((res: any) => {
          if (!res.isSuccess) this.messageService.errorToast(res?.errorMessage);
          else {
            this.supplierQuestionList[parentIndex].fileData.splice(
              childIndex,
              1
            );
            let isAnyFieldBlank = false;
            this.supplierQuestionList[parentIndex].fileData?.forEach(
              (ele: any) => {
                if (!ele?.fileName) isAnyFieldBlank = true;
              }
            );

            // this.isFieldTouched = true;
            // this.fieldTouchedByChild.emit(true);
            this.messageService.successToast('File deleted successfully');
            if (!isAnyFieldBlank) this.addMoreFileDataInTable(parentIndex);
            if (categoryId && questionId && documentTypeId) {
              this.deleteDefaultDocuments(
                categoryId,
                questionId,
                documentTypeId
              );
            }
          }
        });
    }
  }

  DeleteQuestionnaireSingleDocument(
    parentIndex: any,
    childIndex: any,
    categoryId: any,
    questionId: any,
    documentTypeId: any
  ) {
    let requestData = {
      questionnairDocumentId:
        this.supplierQuestionList[parentIndex].fileData[childIndex].documentId,
    };
    this._supplierSvc
      .DeleteQuestionnaireSingleDocument(requestData)
      .subscribe((res: any) => {
        if (!res.isSuccess) this.messageService.errorToast(res?.errorMessage);
        else {
          this.supplierQuestionList[parentIndex].fileData[childIndex] = {
            file: null,
            documentTypeId: null, //this.supplierQuestionList[parentIndex].fileData[childIndex]?.documentTypeId,
            documentTypeName:
              this.supplierQuestionList[parentIndex].fileData[childIndex]
                ?.documentTypeName,
            documentId:
              this.supplierQuestionList[parentIndex].fileData[childIndex]
                ?.documentId,
            fileName: null,
            filepath: null,
          };
          let isAnyFieldBlank = false;
          this.supplierQuestionList[parentIndex].fileData?.forEach(
            (ele: any) => {
              if (!ele?.fileName) isAnyFieldBlank = true;
            }
          );

          // this.isFieldTouched = true;
          // this.fieldTouchedByChild.emit(true);
          this.messageService.successToast('File deleted successfully');
          if (!isAnyFieldBlank) this.addMoreFileDataInTable(parentIndex);

          this.deleteDefaultDocuments(categoryId, questionId, documentTypeId);
        }
      });
  }

  getSupplierSubmittedAnswer() {
    this._supplierSvc
      .GetSupplierAllQuestionTxn(this.supplierId)
      .subscribe((res: any) => {
        res?.data?.forEach((ele: any, index: any) => {
          this.supplierQuestionList[index].answer = ele?.answer;
          this.supplierQuestionList[index].remark = ele?.remark;
          this.supplierQuestionList[index].isRemarkFieldChangedToText =
            ele?.remark ? true : false;

          if (ele?.getSupplierQuestionDoc?.length > 0) {
            this.supplierQuestionList[index].fileData = [];

            ele?.getSupplierQuestionDoc?.forEach((item: any) => {
              let fileName: any = item?.filePath?.split('\\');
              this.supplierQuestionList[index].fileData.push({
                file: null,
                documentTypeId: item?.documentTypeId,
                documentTypeName: item?.documentTypeName,
                documentId: item?.questionnairDocumentId,
                fileName: fileName ? fileName[fileName?.length - 1] : null,
                filepath: item?.filePath,
                rowOnServer: true,
              });
            });
          }
        });
      });
  }

  confirmationDialog(type: string, data: any) {
    var dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '24.514vw',
      height: '12.083vw',
      data: {
        header: type == 'delete' ? 'Delete ?' : 'Save ?',
        data: {
          bodyData:
            type == 'delete'
              ? 'Are you sure, you want to delete this document ?'
              : `Are you sure, you want to submit questions ?`,
        },
        button: {
          isSubmit: type == 'delete' ? false : true,
          isCancel: true,
          isDelete: type == 'delete' ? true : false,
        },
      },
    });
    dialogRef.disableClose = true;

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result == 'ok') {
        if (type == 'delete' && !data?.file)
          this.deleteFileDataInTable(data?.parentIndex, data?.childIndex);
        else if (type == 'delete' && data?.file)
          this.DeleteQuestionnaireSingleDocument(
            data?.parentIndex,
            data?.childIndex,
            data.categoryId,
            data.id,
            data.documentTypeId
          );
        else if (type == 'save') this.saveQuestionerData();
      }
    });
  }

  // validateData() {
  //   this.checkingError = false;
  //   this.supplierQuestionList?.forEach((ele: any) => {
  //     if (ele?.answer && !ele.remark) {
  //       this.checkingError = true;
  //       this.messageService.errorToast('Please fill all required details.');
  //       return;
  //     }
  //   });

  //   if (!this.checkingError) {
  //     this.confirmationDialog('save', '');
  //   }
  // }

  // validateData() {
  //   this.checkingError = false;
  //   this.supplierQuestionList?.forEach((ele: any ) => {
  //     if (
  //       (ele.answer === 'No' || ele.answer === 'Partially') &&
  //       !ele.remark
  //     ) {
  //       this.checkingError = true;
  //       this.messageService.errorToast('Please fill all required details.');
  //       return;
  //     }
  //     else if (ele.answer === 'Yes' && !ele.remark) {
  //       return;
  //     }
  //   });

  //   if (!this.checkingError) {
  //     this.confirmationDialog('save', '');
  //   }
  // }

  validateData() {
    this.checkingError = false;

    this.supplierQuestionList?.forEach((row: any) => {
      row.hasError = false; // Reset error state for each row

      if ((row.answer === 'No' || row.answer === 'Partially') && !row.remark) {
        row.hasError = true; // Set error state for the specific row
        this.checkingError = true; // Keep overall error tracking
      }
    });

    if (this.checkingError) {
      this.messageService.errorToast('Please fill all required details.');
    } else {
      this.confirmationDialog('save', '');
    }
  }

  saveQuestionerData() {
    this.spinner.show();
    var data: any = [];

    this.checkingError = false;

    this.supplierQuestionList?.forEach((row: any) => {
      row.hasError = false; // Reset error state for each row
      row.hasDocError = false;
      row.hasDocTypeError = false;

      // Check if any file uploaded
      const hasUploadedFile = row.fileData.some(
        (f: any) =>
          (f.file && f.file instanceof File) ||
          (f.fileName && f.fileName.trim() !== '')
      );

      // ----------------- YES CASE -----------------
      if (row.answer === 'Yes') {
        row.hasDocTypeError = false;
        row.hasDocError = false;

        row.fileData.forEach((file: any) => {
          // if (!file.documentTypeId) {
          //   row.hasDocTypeError = true;
          //   this.checkingError = true;
          // }
          // if (!file.file && (!file.fileName || file.fileName.trim() === '')) {
          //   row.hasDocError = true;
          //   this.checkingError = true;
          // }
        });
      }

      // ----------------- NO & PARTIAL CASES -----------------
      if (row.answer === 'No' || row.answer === 'Partially') {
        if (!row.remark) {
          row.hasError = true;
          this.checkingError = true;
        }
      }

      // row.fileData.forEach((file: any) => {
      //   if (
      //     file.documentTypeId &&
      //     !file.file &&
      //     (!file.fileName || file.fileName.trim() === '')
      //   ) {
      //     row.hasDocError = true;
      //     this.checkingError = true;
      //   }
      // });
    });

    // ------ If validation error ------
    if (this.checkingError) {
      this.reactiveFormHelperService.scrollToFirstInvalidField();
      this.messageService.errorToast('Please fill all required details.');
      this.spinner.hide();
      return;
    }
    // ------ If no error ------
    this.supplierQuestionList?.forEach((ele: any) => {
      data?.push({
        id: ele?.id ?? 0,
        supplierId: this.supplierId,
        questionTxnid: ele?.supplierQuestionMasterTXNId,
        answer: ele?.answer,
        remark:
          ele?.remark == 'Others'
            ? ele?.otherRemark === null
              ? ele?.remark
              : ele?.remark + ', ' + ele?.otherRemark
            : ele?.remark,
        filePath: 'string',
        fileNew: 'string',
      });
    });

    this._supplierSvc
      .UpdateSupplierQuestionAnswer(data)
      .subscribe((res: any) => {
        if (res.data) {
          this.messageService.successToast('Data saved successfully');
          this.fieldTouchedByChild.emit(false);
          this.GetAllSupplierQuestions();
        } else {
          this.messageService.errorToast(res.errorMessage);
        }
      });
  }

  fieldTouched() {
    this.isFieldTouched = true;
    this.fieldTouchedByChild.emit(true);
  }

  LogEmailRequestSupplierQuestionnaire() {
    let requestData = {
      supplierId: this.supplierId,
      link: `supplier-questioner/${this.supplierId}`,
    };
    this._supplierSvc
      .LogEmailRequestSupplierQuestionnaire(requestData)
      .subscribe((res: any) => {
        if (!res.isSuccess) this.messageService.errorToast(res?.errorMessage);
        else {
          this.messageService.successToast('Email request sent successfully');
        }
      });
  }

  scrollToNextUnfilled() {
    const unfilledQuestion = this.supplierQuestionList?.findIndex(
      (row: any) => {
        return (
          !row.answer ||
          (row.answer && !row.remark) ||
          (row.answer && row.remark == 'Others' && !row.otherRemark)
        );
      }
    );

    if (unfilledQuestion !== -1) {
      const questionRow = this.questionRows.toArray()[unfilledQuestion];
      if (questionRow) {
        questionRow.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
        questionRow.nativeElement.classList.add('highlight');
        setTimeout(
          () => questionRow.nativeElement.classList.remove('highlight'),
          2000
        );
      }
    }
  }

  downloadExcel() {
    this.spinner.show();
    const headerRow = [
      'Topic',
      'Questions',
      'Yes',
      'Partially',
      'No',
      'Remark',
    ];

    let sheetData: any = [];
    this.supplierQuestionList?.forEach((ele: any, index: any) => {
      sheetData.push([
        ele?.topic,
        `${index}. ${ele?.question}`,
        ele?.answer ? (ele?.answer == 'Yes' ? 'True' : 'False') : '',
        ele?.answer ? (ele?.answer == 'Partially' ? 'True' : 'False') : '',
        ele?.answer ? (ele?.answer == 'No' ? 'True' : 'False') : '',
        ele?.remark,
      ]);
    });

    const sheetsConfig: ExcelSheetConfig[] = [
      {
        sheetName: 'Questionnaire_Report',
        headers: [
          ['Questionnaire Report'],
          [
            'Date : ',
            `${this._commonService.getFormattedCurrentDateAndTime()}`,
          ],
          headerRow,
        ],
        data: sheetData,
      },
    ];

    this._excelDownloadService.downloadExcelFile(
      'Questionnaire_Report',
      sheetsConfig
    );
  }

  onUploadClick(event: any, row: any): void {
    if (!row.answer || row.answer === '' || row.answer === null) {
      event.preventDefault();

      this.messageService.errorToast(
        'Please select Yes, No or Partially before uploading a document.'
      );

      row.answerError = true;
      return;
    }

    row.answerError = false;
  }

  removeErrorForDocType(row: any): void {
    row.hasDocTypeError = false;
  }

  checkForDefaultDocument(
    categoryId: number,
    questionId: number,
    documentTypeId: number,
    documentIds: any,
    fileData: any
  ) {
    let docIndex = 0;
    this.supplierQuestionList = this.supplierQuestionList.map((item: any) => {
      let newData = { ...item };
      if (
        item.categoryId == categoryId &&
        item.id !== questionId &&
        item.defaultQuestionId == documentTypeId
      ) {
        newData.answer = 'Yes';
        // newData.fileData = [...(item.fileData ?? [])];
        newData.fileData = (item.fileData ?? []).filter(
          (fd: any) => fd?.file || fd?.documentId
        );
        if (documentIds?.length > 0) {
          newData?.fileData?.push({
            file: fileData.file,
            fileName: fileData.fileName,
            fileExtension: fileData.fileExtension,
            documentId: documentIds[docIndex],
            documentTypeId: documentTypeId,
            documentTypeName: this.allDocumentTypes?.find(
              (docItem: any) => docItem.id == documentTypeId
            )?.documentType,
          });

          docIndex++;
        }
      }
      return newData;
    });
  }

  deleteDefaultDocuments(
    categoryId: any,
    questionId: any,
    documentTypeId: any
  ) {
    this.supplierQuestionList = this.supplierQuestionList.map((item: any) => {
      if (
        item.categoryId == categoryId &&
        item.id !== questionId &&
        item.defaultQuestionId == documentTypeId
      ) {
        return {
          ...item,
          fileData: (item.fileData ?? []).map((fData: any) => ({
            ...fData,
            file: null,
            fileName: null,
            filePath: null,
            documentTypeId: null,
          })),
        };
      }

      return item;
    });
  }
}
